import { apiClient } from './client';

export const assignmentsAndReportsApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getAssignmentsAndReports: builder.query<any, { product_type: any }>({
            query: ({ product_type }) => {
                return {
                    url: `api/assignments?product_type=${product_type}`
                }
            },
        }),
    }),
});

export const { useGetAssignmentsAndReportsQuery } = assignmentsAndReportsApi;
export default assignmentsAndReportsApi;
